import { render, staticRenderFns } from "./TabAddRegisteredUsers.vue?vue&type=template&id=0a441720&"
import script from "./TabAddRegisteredUsers.vue?vue&type=script&lang=js&"
export * from "./TabAddRegisteredUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports